import _ from 'lodash';
export const PNAME = (typeof window !== 'undefined') && `${window.location.protocol}//${window.location.host}${window.location.pathname !== '/' ? window.location.pathname : ''}`;

export function trackPV(EventID) {
  const query = parseUrlQuery();
  const { channelId } = query;
  window.CRGTA.Event.trackPV({
    EventID,
    Body: {
      ACTID: `${PNAME}`,
      channelId: _.isNil(channelId) ? null : channelId,
    },
  });
}

export function trackClick(EventID, others = {}) {
  const query = parseUrlQuery();
  const { channelId } = query;
  window.CRGTA.Event.trackClick({
    EventID,
    Body: {
      ACTID: `${PNAME}`,
      channelId: _.isNil(channelId) ? null : channelId,
      ...others,
    },
  });
}


export function parseUrlQuery() {
  if ((typeof window !== 'undefined')) {
    let searchParams = !_.isEmpty(window.location.search.slice(1)) && window.location.search.slice(1).split('&');
    let hashObject = window.location.hash.slice(2);
    let hashParams = []
    if (!_.isEmpty(hashObject)) {
      if (!_.isEmpty(hashObject.split('?')) && !_.isEmpty(hashObject.split('?')[1])) {
        hashParams = hashObject.split('?')[1].split('&')
      }
    }
    let params = _.isEmpty(searchParams) ? hashParams : searchParams.concat(hashParams);
    let query = {}
    for (let i = 0; i < params.length; i++) {
      const pair = params[i].split('=');
      query[`${pair[0]}`] = decodeURIComponent(pair[1])
    }
    return query;
  }
}